<template>
  <div class="search_w">
    <div class="inp_w">
      <div class="sel_w" v-if="config_info">
        <select type="select" v-model="name">
          <option :key="'account'" :label="'会员账号'" :value="'account'">会员账号</option>
          <template v-if="sale_extend == 1">
            <option :key="'vip_level'" :label="'VIP等级'" :value="'vip_level'" >VIP等级</option>
            <option :key="'e_level'" :label="'电子等级'" :value="'e_level'" >电子等级</option>
            <option :key="'r_level'" :label="'真人等级'" :value="'r_level'" >真人等级</option>
            <option v-if="isShow.levelSalary" :key="'e_up_reward'" :label="'电子晋级礼金'" :value="'e_up_reward'" >电子晋级礼金</option>
            <option v-if="isShow.weekSalary" :key="'e_week_reward'" :label="'电子周俸禄'" :value="'e_week_reward'" >电子周俸禄</option>
            <option v-if="isShow.monthSalary" :key="'e_month_reward'" :label="'电子月俸禄'" :value="'e_month_reward'" >电子月俸禄</option>
            <option v-if="isShow.levelSalary" :key="'r_up_reward'" :label="'真人晋级礼金'" :value="'r_up_reward'" >真人晋级礼金</option>
            <option v-if="isShow.monthSalary" :key="'r_month_reward'" :label="'真人月俸禄'" :value="'r_month_reward'" >真人月俸禄</option>
          </template>
          <template v-else>
            <option :key="'e_level'" :label="'等级'" :value="'e_level'" v-if="Number(config_info.search_e_level)">等级</option>
            <option :key="'sale_price'" :label="'标价'" :value="'sale_price'" v-if="Number(config_info.search_price)">标价</option>
            <option :key="'e_up_reward'" :label="'等级礼金'" :value="'e_up_reward'" v-if="Number(config_info.search_e_up_reward)">等级礼金</option>
            <option v-if="isShow.weekSalary" :key="'e_week_reward'" :label="'周俸禄'" :value="'e_week_reward'">周俸禄</option>
            <option v-if="isShow.monthSalary" :key="'e_month_reward'" :label="'月俸禄'" :value="'e_month_reward'">月俸禄</option>
        
          </template>
        </select>
        <i class="icon xia"></i>
      </div>
      <input type="text" class="input_c" v-model="value">
    </div>
    <div class="sea_btn" @click="search()">搜索</div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: 'search',
    data () {
      return {
        value: '',
        name: 'account',
        sale_extend: ''
      }
    },
    computed: {
      ...mapState(['config_info']),
      isShow() {
        const info = this.config_info ? this.config_info : {}
        const weekSalary = Number(info.week_salary_status) === 1
        const monthSalary = Number(info.month_salary_status) === 1
        const levelSalary = Number(info.finance_salary_status) === 1
        return { weekSalary, monthSalary, levelSalary }
      }
    },
    created () {
      this.sale_extend = localStorage.getItem('sale_extend')
      if (!this.isObj(this.$route.query)) {
        this.name = Object.keys(this.$route.query)[0]
        this.value = this.$route.query[this.name]
      }
    },
    mounted () {
    },
    methods: {
      isObj (obj) {
        var b = (JSON.stringify(obj) === '{}')
        return b
      },
      search () {
        if (!this.value) {
          this.$toast('输入内容不能为空')
          return
        }
        let ret = this.name
        let formq = {}
        formq[ret] = this.value
        let rname = '/' + this.$route.name
        if (this.$route.name === 'index') {
          this.$router.push({path: '/hall', query: formq})
        } else {
          this.$router.replace({path: rname, query: formq})
        }
      }
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~@/common/stylus/mixin.styl"
  .search_w
    margin-top 0.2rem
    padding 0 0.28rem
    display flex
    font-size 0.28rem
    justify-content space-between
    .inp_w
      height 0.8rem
      background-color #fff
      border 1px solid #cccccc
      border-radius 0.1rem
      width 5.6rem
      box-sizing border-box
      color #666666
      display flex
      align-items center
      .sel_w
        border-right 1px solid #666666
        height 0.4rem
        select
          background-color #fff
          margin-left 0.32rem
          border none
          text-align center
          text-align-last center
          outline none
          appearance none
          -moz-appearance none
          -webkit-appearance none
        .icon
          margin-right 0.1rem
          display inline-block
          width 0.1rem
          height 0.1rem
          bg-image('xiabiao')
          background-size cover
      .input_c
        outline none
        line-height 0.6rem
        padding-left 0.1rem
        width 3rem
    .sea_btn
      background-color #f99a22
      color #fff
      border-radius 0.1rem
      line-height 0.8rem
      text-align center
      width 1.2rem
</style>



// WEBPACK FOOTER //
// src/components/common/search/search.vue